<template>
  <div
    id="element"
    class="login"
  >
    <div class="login--item ">
      <Header/>
    </div>
    <div class="section-gray">
      <div class="section-white">
        <LoginModal
          @loginSuccess="congratsAfterLogin"
        />
      </div>
    </div>
    <div class="login--item">
      <Footer/>
    </div>
  </div>
</template>

<script>
import Header from '@/features/Header'
import LoginModal from '@/features/LoginModal'
import Footer from '@/components/Footer'
import CongratsToGetReward from '@/components/CongratsToGetReward'
import { calTotalKULToken } from '@/utils/helper'
import { kulapApi } from '@/resources'
import Service from './service.js'
import { mapState } from 'vuex'
import cookie from '@/utils/cookie'

export default {
  name: 'Login',
  components: {
    LoginModal,
    Header,
    Footer,
    CongratsToGetReward
  },
  data () {
    return {
      service: null
    }
  },
  computed: {
    ...mapState({
      user: state => state.user
    })
  },
  created () {
    if (cookie.get('user') || cookie.get('accessToken')) {
      this.$router.push({ name: 'Exchange' })
      return
    }
    this.service = new Service({ store: this.$store, kulapApi })
  },
  methods: {
    async congratsAfterLogin () {
      const data = this.user
      if (data && data.rewards && data.rewards.length) {
        const filterRewards = data.rewards.filter(e => e.options.isOpenCongratsModal)
        if (filterRewards.length) {
          let subTitle = ''
          if (filterRewards.find(e => e.name === 'Registration')) subTitle = this.$t('messages.thanks_for_registration')
          else if (filterRewards.find(e => e.name === 'KYCApproved')) subTitle = this.$t('messages.thanks_for_submited')
          this.$buefy.modal.open({
            parent: this,
            component: CongratsToGetReward,
            hasModalCard: true,
            props: {
              tokenAmount: calTotalKULToken(filterRewards),
              subTitle
            },
            canCancel: ['escape', 'outside']
          })
          const changeRewardsOption = filterRewards.map(e => ({ ...e, options: { isOpenCongratsModal: false } }))
          await kulapApi.putRewardsOption(changeRewardsOption)
          await this.service.updateUserData()
        }
      }
      this.$router.push({ name: this.$route.query.next || 'Exchange' })
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  float: left;
  width: 100%;
  min-height: 100vh;

  &--item {
    float: left;
    width: 100%;
  }
}
.section-gray {
  float: left;
  width: 100%;
  padding-bottom: 170px;
  text-align: center;
}
.section-white {
  display: inline-block;
  // padding: 32px 47px;
  width: fit-content;
  border-radius: 5px;
  box-shadow: 0 2px 4px -3px rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/pages/Login/index.vue